import React from 'react';
import type { Placement } from '@popperjs/core';
import { useIntl } from '@atlassian/jira-intl';
import { PAGES_CREATE_PAGE_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import {
	DEFAULT_NUDGE_WIDTH,
	PACKAGE_NAME,
} from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import {
	DEFAULT_SCROLL_TO_NUDGE,
	POSITION_TOP_START,
} from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/instrumented-nudge-spotlight-card/constants.tsx';
import { useTrackMountedNudgesController } from '@atlassian/jira-software-onboarding-quickstart-track-mounted-nudges/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { PortalledNudge } from '../../common/ui/portalled-nudge/index.tsx';
import { usePageNudgeTour } from '../../controllers/page-nudge-tour/index.tsx';
import messages from './messages.tsx';

export const PagesCreatePageNudge = () => {
	useTrackMountedNudgesController(PAGES_CREATE_PAGE_NUDGE_ID);
	const { formatMessage } = useIntl();
	const pageViewNudgeTourProps = usePageNudgeTour(PAGES_CREATE_PAGE_NUDGE_ID);

	const position: Placement = POSITION_TOP_START;
	const nudgeSpotlightProps = {
		content: formatMessage(messages.pagesViewNudgeContent),
		width: DEFAULT_NUDGE_WIDTH,
		position,
		scrollToNudge: DEFAULT_SCROLL_TO_NUDGE,
	};
	return (
		<JSErrorBoundary id="pagesCreatePageNudge" packageName={PACKAGE_NAME} fallback="unmount">
			<PortalledNudge
				nudgeIdForAnalytics={PAGES_CREATE_PAGE_NUDGE_ID}
				nudgeTargetId={PAGES_CREATE_PAGE_NUDGE_ID}
				nudgeBlinkId={PAGES_CREATE_PAGE_NUDGE_ID}
				hideNudgeOnClick
				hideSpotlightCardOnOutsideClick
				{...nudgeSpotlightProps}
				{...pageViewNudgeTourProps}
			/>
		</JSErrorBoundary>
	);
};
